export default {
  home: {
    ios: 'iPhoneHome',
    andriod: 'sc-home'
  },
  detail: {
    ios: 'detail?id=',
    andriod: 'detail?id='
  },
  ma: {
    ios: 'myAlibaba',
    andriod: 'sc-home?frag=MA'
  },
  list: {
    ios: 'list',
    andriod: 'list'
  },
  chat: {
    ios: 'atmTalking',
    andriod: 'atmTalking'
  },
  messageList: {
    ios: 'messageMain',
    andriod: 'sc-home?frag=Messenger'
  }
}


// WEBPACK FOOTER //
// ./src/listen-download-app/pageSchema.js